// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-10896988194");
  window.gtag("event", "conversion", {
    send_to: ["AW-10896988194/o8obCOjL47oDEKKwi8wo"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze"
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
  
}

// ----------------- END PURCHASE SCRIPT --------------------------------------
